var _rect, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgRoofing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4223_1759",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4223_1759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66021 16.2498V11.5703H12.3398V16.2498H7.66021ZM8.91021 14.9998H11.0898V12.8203H8.91021V14.9998ZM2.00167 10.5125L1.25 9.51588L10 2.9165L13.4775 5.53025V3.74984H15.5127V7.07046L18.7579 9.51588L18.0065 10.5125L10 4.49171L2.00167 10.5125Z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofing);
export default __webpack_public_path__ + "static/media/roofing.224ad0ff.svg";
export { ForwardRef as ReactComponent };